/** Cookie: el usuario eligió no volver a mostrar el aviso de permisos de notificación en este navegador. */
export const PUSH_PROMPT_DECLINED_COOKIE = 'orgcloud_push_prompt_declined';
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 400; // ~13 meses

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function isPushPromptDeclinedInCookie(): boolean {
  return readCookie(PUSH_PROMPT_DECLINED_COOKIE) === '1';
}

export function setPushPromptDeclinedCookie(): void {
  if (typeof document === 'undefined') return;
  try {
    const secure = typeof window !== 'undefined' && window.location?.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${PUSH_PROMPT_DECLINED_COOKIE}=1; Path=/; Max-Age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax${secure}`;
  } catch {
    /* noop */
  }
}
